import { render, staticRenderFns } from "./DetailActual.vue?vue&type=template&id=58cc4ae0"
import script from "./DetailActual.vue?vue&type=script&lang=js"
export * from "./DetailActual.vue?vue&type=script&lang=js"
import style0 from "./DetailActual.vue?vue&type=style&index=0&id=58cc4ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports